import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=5e1c143e&scoped=true&"
import script from "./SignDocument.vue?vue&type=script&lang=js&"
export * from "./SignDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1c143e",
  null
  
)

export default component.exports